import { MAIN_COLOR } from "../../../constants/common/utils";
import { TXButtonTemplate } from "../../../types/common/templates.types";

export const X_BUTTON_TEMPLATES: TXButtonTemplate = {
  "Button par defaut": {
    template: [
      {
        name: "XButton",
        props: {
          all: {
            text: "Button",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
          },
        },
      },
    ],
  },
  "Button Arrondi": {
    template: [
      {
        name: "XButton",
        props: {
          all: {
            text: "Button",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
            borderRadius: {
              TopLeft: "5px",
              TopRight: "5px",
              BottomLeft: "5px",
              BottomRight: "5px",
            },
          },
        },
      },
    ],
  },
  "Button en Pillule": {
    template: [
      {
        name: "XButton",
        props: {
          all: {
            text: "Button",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
            borderRadius: {
              TopLeft: "25px",
              TopRight: "25px",
              BottomLeft: "25px",
              BottomRight: "25px",
            },
          },
        },
      },
    ],
  },
  "Button Bordé": {
    template: [
      {
        name: "XButton",
        props: {
          all: {
            text: "Button",
            color: MAIN_COLOR,
            border: { style: "solid", width: "2px", color: MAIN_COLOR },
            width: "100px",
            textAlign: "center",
            fontWeight: 600,
            padding: { Top: "10px", Bottom: "10px" },
            borderRadius: {
              TopLeft: "5px",
              TopRight: "5px",
              BottomLeft: "5px",
              BottomRight: "5px",
            },
          },
        },
      },
    ],
  },
  "Groupe de Buttons": {
    template: [
      {
        name: "XStack",
        config: { index: "BTN_GROUP" },
        props: { all: { width: "300px", direction: "row" } },
      },
      {
        name: "XButton",
        config: { index: "BTN_1", childOf: "BTN_GROUP" },
        props: {
          all: {
            text: "Button 1",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
            borderRadius: {
              TopLeft: "8px",
              BottomLeft: "8px",
            },
          },
        },
      },
      {
        name: "XButton",
        config: { index: "BTN_2", childOf: "BTN_GROUP" },
        props: {
          all: {
            text: "Button 2",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
          },
        },
      },
      {
        name: "XButton",
        config: { index: "BTN_3", childOf: "BTN_GROUP" },
        props: {
          all: {
            text: "Button 3",
            bgColor: MAIN_COLOR,
            color: "#ffffff",
            fontWeight: 600,
            width: "100px",
            textAlign: "center",
            padding: { Top: "10px", Bottom: "10px" },
            borderRadius: {
              TopRight: "8px",
              BottomRight: "8px",
            },
          },
        },
      },
    ],
  },
};
